module.exports = __webpack_public_path__ + "e9c477e8/img/menu-icon.5f8facae.svg";